<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-03-24 04:21:54
    Description : gaia48
  -->
  <div class="main">
    <gaia-48 />
    <div style="height: 70px"></div>
    <el-carousel :height="`${bannerHeight}px`">
      <el-carousel-item v-for="(item, i) in bannerList" :key="item.id">
        <img
          :src="`${VUE_APP_RESOURCES_URL}${item.picture}`"
          @click="openBanner(item.url)"
        />
      </el-carousel-item>
    </el-carousel>
    <!-- notice -->
    <div class="notice"></div>
    <div class="content" v-html="content"></div>
    <!-- 步骤 -->
    <div>
      <img :src="stepImg" />
      <div style="text-align: center; margin: -60px 0 60px">
        <a href="/desktop/gaia-48/info?index=4" style="color: #ffa200">
          详细时间表>
        </a>
      </div>
    </div>
    <!-- 便捷入口 -->
    <div style="text-align: center; margin-top: 140px">
      <img
        :src="bianjieList[0].picture"
        style="width: 394px; height: 200px; cursor: pointer"
        @click="jumpTo(bianjieList[0].url)"
      />
      <img
        :src="bianjieList[1].picture"
        style="width: 252px; height: 200px; cursor: pointer"
        @click="jumpTo(bianjieList[1].url)"
      />
      <img
        :src="bianjieList[2].picture"
        style="width: 314px; height: 200px; cursor: pointer"
        @click="jumpTo(bianjieList[2].url)"
      />
      <br />
      <img
        :src="bianjieList[3].picture"
        style="width: 394px; height: 200px; cursor: pointer;margin-top:-4px"
        @click="jumpTo(bianjieList[3].url)"
      />
      <img
        :src="bianjieList[4].picture"
        style="width: 566px; height: 200px; cursor: pointer;margin-top:-4px"
        @click="jumpTo(bianjieList[4].url)"
      />
      <div class="bianjie1">
        {{ bianjieList[0].topic }}
        <br />
        <span style="font-size: 36px; margin-left: -38px">{{
          bianjieList[0].title
        }}</span>
      </div>
      <div class="bianjie2">
        {{ bianjieList[1].topic }}
        <br />
        <span style="font-size: 36px; margin-left: -30px">{{
          bianjieList[1].title
        }}</span>
      </div>
      <div class="bianjie3">
        {{ bianjieList[2].topic }}
        <br />
        <span style="font-size: 36px; margin-left: -4px">{{
          bianjieList[2].title
        }}</span>
      </div>
      <div class="bianjie4">
        {{ bianjieList[3].topic }}
        <br />
        <span style="font-size: 36px; margin-left: -38px">{{
          bianjieList[3].title
        }}</span>
      </div>
      <div class="bianjie5">
        <div style="margin-top: 46px">
          {{ bianjieList[4].topic }}
        </div>
        <br />
        <!-- <span style="font-size: 36px">{{ bianjieList[4].title }}</span> -->
      </div>
    </div>
    <div>
      <img
        class="zhuban"
        src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/151678968640940f9.jpg"
      />
      <img
        class="zhuban"
        v-for="(item, i) in zhubanList"
        :key="i"
        :src="item.picture"
        @click="jumpTo(item.url)"
      />
    </div>
  </div>
</template>

<script>
import Gaia48 from "@/components/gaia-header/gaia-48";
import { getBannerList, getHomeSettingList } from "@/api/newgaia48";
export default {
  components: {
    Gaia48,
  },
  data() {
    return {
      VUE_APP_RESOURCES_URL: process.env.VUE_APP_RESOURCES_URL,
      height: "400px",
      bannerHeight: 0,
      // 浏览器宽度
      screenWidth: 0,
      bannerList: [],
      content: "",
      stepImg: "",
      zhubanList: [],
      bianjieList: [{ picture: "" }, { picture: "" }, { picture: "" }],
    };
  },
  created() {
    this.getBannerList();
    this.getHomeSettingList();
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      if (window.innerWidth >= 1300) {
        this.screenWidth = window.innerWidth;
        this.setSize();
      }
    };
  },
  methods: {
    /**
     * 通过浏览器宽度(图片宽度)计算高度
     */
    setSize() {
      this.bannerHeight = (800 / 1920) * this.screenWidth;
    },
    /**
     * banner 列表
     */
    getBannerList() {
      getBannerList().then((res) => {
        console.log(res);
        this.bannerList = res.bannerList;
      });
    },
    getHomeSettingList() {
      getHomeSettingList().then((res) => {
        this.content = res.settings.content;
        this.stepImg = this.VUE_APP_RESOURCES_URL + res.settings.timelineCover;
        this.zhubanList = res.orginized.map((el) => {
          return {
            picture: this.VUE_APP_RESOURCES_URL + el.picture,
            url: el.url,
          };
        });
        this.bianjieList = res.bannerList.map((el) => {
          return {
            picture: this.VUE_APP_RESOURCES_URL + el.picture,
            url: el.url,
            title: el.title,
            topic: el.topic,
          };
        });
      });
    },
    openBanner(url) {
      if (url) {
        if (!url.includes("http")) {
          url = "http://" + url;
        }
        open(url);
      }
    },
    jumpTo(url) {
      if (!url.includes("http")) {
        url = "http://" + url;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="less">
.content {
  p {
    line-height: 2;
    min-height: 37px;
  }
}
</style>
<style lang="less" scoped>
.el-carousel__item {
  font-size: 14px;
  line-height: 300px;
  margin: 0;
}
.main {
  min-width: 1300px;
  overflow-x: hidden;
}
img {
  width: 100%;
  height: inherit;
}
.zhuban {
  display: block;
  width: 200px;
  height: auto;
  margin: 0px auto 100px;
}
.bianjie1 {
  position: relative;
  height: 0;
  top: -290px;
  left: -400px;
  font-size: 18px;
  // font-weight: 700;
  font-family: Adobe 黑体 Std;
  color: #ffa200;
}
.bianjie2 {
  position: relative;
  height: 0;
  top: -290px;
  font-size: 18px;
  // font-weight: 700;
  font-family: Adobe 黑体 Std;
  color: #ffffff;
}
.bianjie3 {
  position: relative;
  height: 0;
  top: -290px;
  left: 250px;
  font-size: 18px;
  // font-weight: 700;
  font-family: Adobe 黑体 Std;
  color: #ffa200;
}
.bianjie4 {
  position: relative;
  height: 100px;
  top: -100px;
  left: -400px;
  font-size: 18px;
  // font-weight: 700;
  font-family: Adobe 黑体 Std;
  color: #ffffff;
}
.bianjie5 {
  position: relative;
  height: 0;
  top: -200px;
  left: 0px;
  font-size: 18px;
  // font-weight: 700;
  font-family: Adobe 黑体 Std;
  color: #ffa200;
}
</style>
